import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import * as headerActions from '../../actions/header.js';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Scrollspy from 'react-scrollspy';
import { slide as Menu } from 'react-burger-menu';
import ReactGA from 'react-ga';

class Header extends Component {

  componentDidMount() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log("Will not init GA because you're in development mode");
    } else {
      ReactGA.initialize('UA-25499721-4');
      ReactGA.pageview(window.location.pathname + window.location.hash);
    }

    this.props.dispatch(headerActions.loadHeader());
  }

  setHash = (obj) => {
    if(ReactDOM.findDOMNode(obj).getAttribute('id') === "home") {
      ReactDOM.findDOMNode(obj).querySelector('#logo').setAttribute('src',"images/logo-alt.png");
    } else {
      ReactDOM.findDOMNode(this.refs.logo).setAttribute('src',"images/logo.png");
    }

    if(window.history.pushState) {
      window.history.pushState(null, null, "#"+ReactDOM.findDOMNode(obj).getAttribute('id'));
    } else {
      window.location.hash = "#1"+ReactDOM.findDOMNode(obj).getAttribute('id')
    }

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log("Will not fire GA because you're in development mode");
    } else {
      ReactGA.pageview(window.location.pathname + window.location.hash);
    }
  };

  render() {
    const { header, error } = this.props.header;
    const loading = this.props.loading;

    if(loading.loading) { return <header id="home" ref={this.props.innerRef} /> }
    if(error) { return "error" }

    return (
      <header id="home" ref={this.props.innerRef}>

        <Menu right pageWrapId={ "page_wrap" } outerContainerId={ "root" }>
          <Scrollspy id="nav" items={['home','about','skills','portfolio','contact']} currentClassName="current" offset={-48} onUpdate={this.setHash}>
            <li className="current"><a href="#home"><img src="images/logo.png" id="logo" ref="logo" /></a></li>
            <li><AnchorLink href="#about">About</AnchorLink></li>
            <li><AnchorLink href="#skills">Skills</AnchorLink></li>
            <li><AnchorLink href="#portfolio">Works</AnchorLink></li>
            <li><AnchorLink href="#contact">Contact</AnchorLink></li>
          </Scrollspy>
        </Menu>

        <div className="row banner">
          <div className="banner-text">
            <h1 className="responsive-headline" dangerouslySetInnerHTML={{__html: header.filter(item => item.name === "header_h1")[0].content}} />
            <h3 dangerouslySetInnerHTML={{__html: header.filter(item => item.name === "header_blurb")[0].content}} />
          </div>
        </div>
        <p className="scrolldown">
          <a className="smoothscroll" href="#about"><i className="icon-down-circle" /></a>
        </p>
      </header>

    );
  }
}

const mapStateToProps = state => ({
  ...state,
  header: state.header
});

export default connect(mapStateToProps, null, null, {withRef: true})(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js